import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PartySignupPageService } from 'app/router-wrapper/services/party-signup-page/party-signup-page.service';
import { PartySignupPopoverComponent } from '../party-signup-popover/party-signup-popover.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { PartySignupTabsPopoverComponent } from '../party-signup-tabs-popover/party-signup-tabs-popover.component';
import { PartySignupTabsService } from 'app/manage-party-signup/services/party-signup-tabs.service';

@Component({
  selector: 'app-party-signup-card',
  standalone: true,
  imports: [PartySignupPopoverComponent,CommonModule,CoreModule,PartySignupTabsPopoverComponent],
  templateUrl: './party-signup-card.component.html',
  styleUrl: './party-signup-card.component.scss'
})
export class PartySignupCardComponent {
  @Input() public selectedPartySignup;
  public typeData;
  public isDownloadHovered = false;
  public img = '/images/org_logo_default_v2.svg';
  public statusType:"Active" | "Hidden" | "Ended" | "Deactivated" | "Not started"
  ACTIVE_CAMPAIGN = 0;
  EXPIRED_CAMPAIGN = 1;
  DEACTIVATED_CAMPAIGN = 2;
  NOT_STARTED = 3;
  constructor(
    private router :Router,
    public partySignupPageService: PartySignupPageService,
   private tabsService:PartySignupTabsService
  )
  {}
  ngOnInit(): void {
    if(this.selectedPartySignup.imageUrl){
      this.img = this.selectedPartySignup.imageUrl;
    }

    this.typeData = this.selectedPartySignup.campaignTypeData;
    this.setPartysignupCampaignStatus();
  }

  setPartysignupCampaignStatus(){
    if(this.selectedPartySignup.status === this.ACTIVE_CAMPAIGN){
      this.statusType = this.selectedPartySignup.isDefault ? "Active" : "Hidden"
      return;
    }

    if(this.selectedPartySignup.status === this.EXPIRED_CAMPAIGN){
      this.statusType = "Ended"
      return;
    }

    if(this.selectedPartySignup.status === this.DEACTIVATED_CAMPAIGN){
      this.statusType = "Deactivated"
      return;
    }

    if(this.selectedPartySignup.status === this.NOT_STARTED){
      this.statusType = "Not started";
      return;
    }
  }
  
  openPartySignupDetailsPage(event){
    if(!event.target.matches('.noDetaisClick')){
      this.tabsService.selectedTab = 'paid';
      this.router.navigate(['manage/party-signup', this.selectedPartySignup.id], { fragment: "paidTab"});
    }
  
  }
}
